import type { Title } from "@/mocks/titles";
import { useToast } from "@/components/base/Toast";

interface DetailActionsProps {
  title: Title;
  saved: boolean;
  onToggleSave: () => void;
  onShared: () => void;
}

export default function DetailActions({ title, saved, onToggleSave, onShared }: DetailActionsProps) {
  const { notify } = useToast();

  const handleShare = async () => {
    const url = window.location.href;
    const shareData = { title: `${title.name} - 星光传媒`, text: title.tagline, url };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
        onShared();
        return;
      }
      await navigator.clipboard.writeText(url);
      onShared();
    } catch {
      notify("已取消分享或浏览器不支持自动复制，可手动复制地址栏链接");
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button
        type="button"
        onClick={onToggleSave}
        className={`inline-flex items-center gap-2 h-10 px-4 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
          saved
            ? "bg-accent-500 text-primary-950"
            : "bg-background-50/10 text-background-100 border border-background-50/25 hover:bg-background-50/20"
        }`}
      >
        <i
          className={`${saved ? "ri-heart-fill" : "ri-heart-line"} text-base w-4 h-4 flex items-center justify-center`}
        ></i>
        {saved ? "已收藏" : "收藏"}
      </button>
      <button
        type="button"
        onClick={handleShare}
        className="inline-flex items-center gap-2 h-10 px-4 rounded-md text-sm bg-background-50/10 text-background-100 border border-background-50/25 hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-share-forward-line text-base w-4 h-4 flex items-center justify-center"></i>
        分享
      </button>
      <button
        type="button"
        onClick={() => notify("演示站点暂不提供在线播放，敬请期待正式版本")}
        className="inline-flex items-center gap-2 h-10 px-4 rounded-md text-sm bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-play-fill text-base w-4 h-4 flex items-center justify-center"></i>
        观看预告（演示）
      </button>
      {saved && (
        <span className="text-[11px] text-background-300/80">收藏状态仅在当前页面保留，刷新后清空</span>
      )}
    </div>
  );
}